import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


export default new Vuex.Store({
	state:{
        city:'',
        custom:0,
        block:''
    },
	getters:{},
	actions:{},
	mutations:{
        setCity(state,newCity){
            state.city=newCity
        },
        setMap(state,block){
          state.block = block;
        },
        custom(state,num){
          state.custom = 1;
        }
    },
})



// WEBPACK FOOTER //
// ./src/vuex/index.js